import { formatAuthor } from "../common"

export const format = (out: any, item: any, meta: any, nl: string) => {

  let frmt = "@" + getBibType(item, meta) + "{"

  frmt += item?.user_data?.citekey || item?.ext_ids?.doi
  frmt += `, ${nl}`

  frmt += Object
    .entries(out)
    .map(entry => {
      const [ key, value ] = entry
      const escVal = ["local-url", "author"].includes(key) ? value : bibEsc(value)
      return ["title", "abstract"].includes(key)
        ? `${key} = {{${escVal}}}`
        : `${key} = {${escVal}}`
    })
    .join(", " + nl)

  frmt += `${nl}}`
  return frmt
}

function getBibType(item: any, meta: any) {
  if (!item.custom_metadata || !item.custom_metadata.type)
    return "article"

  const typeName = item.custom_metadata.type
  const typeDef  = meta.types[typeName]

  if (!typeDef)
    return "article"

  return typeDef.bib_type || "article"
}

function bibEsc(value: any) {
  return typeof value !== "string"
    ? value
    : value
      .replace('\n', ' ')
      .replace(/~/g, "\\textasciitilde")
      .replace(/\\/g, "\\textbackslash")
      .replace(/\^/g, "\\textasciicircum")
      .replace(/[&%$#_{}]/g, "\\$&")
}

export function bibAuthorFormat(val: any) {
  return Array.isArray(val)
      ? val
          .map(formatAuthor)
          .map((a: any) => a?.split(" ").includes("and") ? "{" + bibEsc(a) + "}" : bibEsc(a))
          .join(" and ")
      : []
}
